import React from 'react';
import './AnalysesSang.css';
import { Link } from 'react-router-dom';
import { FaVial, FaHeartbeat, FaFlask } from 'react-icons/fa';
import { useLanguage } from '../i18n/LanguageContext';

const AnalysesSang = () => {
  const { t } = useLanguage();
  const services = [
    {
      icon: <FaVial size={40} color="#00c4ff" />,
      title: t('servicesPages.bloodTestsSamplingTitle'),
      description: t('servicesPages.bloodTestsSamplingBody'),
    },
    {
      icon: <FaHeartbeat size={40} color="#00c4ff" />,
      title: t('servicesPages.bloodTestsEcgTitle'),
      description: t('servicesPages.bloodTestsEcgBody'),
    },
    {
      icon: <FaFlask size={40} color="#00c4ff" />,
      title: t('servicesPages.bloodTestsResultsTitle'),
      description: t('servicesPages.bloodTestsResultsBody'),
    },
  ];

  return (
    <>
      {/* Section principale */}
      <section className="analyses-header">
        <div className="analyses-text">
          <h5>{t('servicesPages.label')}</h5>
          <h1>{t('servicesPages.bloodTestsTitle')}</h1>
          <p>{t('servicesPages.bloodTestsBody')}</p>
        </div>

        <div className="analyses-image-wrapper">
          <div className="purple-bar"></div>
          <img
            src="/images/analyse-de-sang.webp"
            alt="Analyses de sang"
            className="analyses-main-image"
          />
        </div>
      </section>

      {/* Cartes */}
      <section className="analyses-cards">
        <h5>{t('servicesPages.label')}</h5>
        <h2>{t('servicesPages.bloodTestsCardsTitle')}</h2>
        <p>{t('servicesPages.bloodTestsCardsBody')}</p>

        <div className="analyses-card-grid">
          {services.map((service, index) => (
            <div key={index} className="analyses-card">
              <div className="icon">{service.icon}</div>
              <h4>{service.title}</h4>
              <p>{service.description}</p>
              <Link to="/prendre-rdv" className="rdv-button">
                {t('servicesPages.bookCta')} <span>+</span>
              </Link>
            </div>
          ))}
        </div>
      </section>
    </>
  );
};

export default AnalysesSang;
